import React, { Component } from 'react';
import './libros.css';
// import ItemLibro from "./itemlibro";
// import { Link } from "react-router-dom";
// import { Col, Row, } from 'react-bootstrap';
// import { GridList, GridTile } from "material-ui/GridList";
import { Image, Col, Row, Grid } from 'react-bootstrap';
import Contenido from './itemlibro.js';
import libros from './librosCover';

export default class Libros extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  componentWillMount() {}
  renderBooks() {
    var tmpEle = [];
    for (let i = 0; i < Math.ceil(libros.length / 2); i++) {
      if (libros[i * 2 + 0] !== undefined && libros[i * 2 + 1] !== undefined) {
        tmpEle.push(
          <Row bsClass="row" style={{ marginBottom: 30 }} key={libros[i * 2 + 0].route}>
            <Col xs={12} md={6}>
              <Contenido data={libros[i * 2 + 0]} />
            </Col>
            <Col xs={12} md={6}>
              <Contenido data={libros[i * 2 + 1]} />
            </Col>
          </Row>
        );
      } else if (libros[i * 2 + 0] !== undefined) {
        tmpEle.push(
          <Row bsClass="row" style={{ marginBottom: 30 }} key={libros[i * 2 + 0].route}>
            <Col xs={12} md={6}>
              <Contenido data={libros[i * 2 + 0]} />
            </Col>
          </Row>
        );
      }
    }

    return tmpEle.map((item, index) => {
      return item;
    });
  }
  render() {
    return (
      <div className="navMargin" style={{ height: '100%' }}>
        <section
          style={{
            paddingTop: '2%',
            backgroundColor: '#b3c6cf',
            display: 'flex',
            flexDirection: 'column',
            height: 'auto',
            minHeight: '100%',
          }}
        >
          <p
            style={{
              color: '#352a35',
              textAlign: 'center',
              fontSize: '60pt',
              fontWeight: 'Bold',
            }}
          >
            Libros
          </p>
          <Image
            src={require('../../img/lineRevistas.png')}
            style={{
              marginLeft: 'auto',
              marginRight: 'auto',
              display: 'block',
            }}
            responsive
          />
          <div style={{ height: 25 }} />
          <Grid>{this.renderBooks()}</Grid>
        </section>
      </div>
    );
    // <div className="navMargin container">
    //   <h2>Libros</h2>
    //   <div>
    //     <GridList cellHeight={400}>
    //       {libros.map((tile, i) => {
    //         console.log(tile);
    //         return (
    //           <Link to={"/compra/" + (i + 1)} target="_blank">
    //             <GridTile
    //               style={{
    //                 color: "rgba(0, 0, 0, 0.87)",
    //                 backgroundColor: "#1AA6AC",
    //                 transition:
    //                   "all 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms",
    //                 boxSizing: "border-box",
    //                 fontFamily: "Roboto, sans-serif",
    //                 WebkitTapHighlightColor: "rgba(0, 0, 0, 0)",
    //                 boxShadow:
    //                   "rgba(0, 0, 0, 0.12) 0px 1px 6px, rgba(0, 0, 0, 0.12) 0px 1px 4px",
    //                 borderRadius: 2,
    //                 zIndex: 1,
    //                 marginBottom: 20
    //               }}
    //               key={i}
    //               title={tile.title}
    //               subtitle={
    //                 <div>
    //                   <span>
    //                     by <b>{tile.author}</b>
    //                   </span>
    //                   <span style={{ marginLeft: 16, color: "#D0FDE2" }}>
    //                     $ {Number(tile.precio).toFixed(2)} +{" "}
    //                     {Number(tile.envio).toFixed(2)} de envio
    //                   </span>
    //                 </div>
    //               }
    //             >
    //               <img
    //                 src={tile.img}
    //                 style={{
    //                   paddingBottom: 68,
    //                   objectFit: "contain",
    //                   top: "0% !important",
    //                   height: "100%",
    //                   width: "100%"
    //                 }}
    //                 alt={tile.title}
    //               />
    //             </GridTile>
    //           </Link>
    //         );
    //       })}
    //     </GridList>
    //     <Row>
    //       <Col sm={12} md={6}>
    //         <ItemLibro title={"La Empresa Hoy: Los Nuevos Retos Financieros y Fiscales"} costo={"$ 185.00 + envio"}/>
    //       </Col>
    //       <Col  sm={12} md={6}>
    //         <ItemLibro title={"Movilidad Social e Inclusión Social y Educativa y Laboral de Egresados del Bachillerato a Distancia"} costo={"$ 185.00 + envio"}/>
    //       </Col>
    //     </Row>
    //   </div>
    // </div>
  }
  componentDidMount() {}
  componentWillUnmount() {}
}



// WEBPACK FOOTER //
// ./src/views/libros/index.js